import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { initI18n } from '@/i18n/config';
import { App } from '@/app/root';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

await initI18n();

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
